import React from 'react';
import styled from 'styled-components';
import { BaseHeadingStyle } from './new/headers';
import Img from 'gatsby-image';

const Card = styled.div`
    position: relative;
    display: block;
    width: 100%;

    &.base-card_wide {
        background-image: url(${props => props.image});
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        align-self: stretch;
        display: flex;
        padding: 0 24px 32px;
        box-sizing: border-box;
        border-radius: 16px;
        overflow: hidden;
        height: 100%;

        &:before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(255, 255, 255, 0.5);
            z-index: 1;
        }

        .base-card__title-wrap {
            align-self: flex-end;
            position: relative;
            z-index: 1;
        }

        .base-card__date {
            font-size: 18px;
        }

        @media screen and (max-width: 1200px) {
            padding: 0 16px 32px;
        }
        @media screen and (max-width: 400px) {
            background-image: url(${props => props.smallBackground});
        }
    }

    .base-card__date {
        font-family: 'Circe Web';
        font-size: 14px;
        line-height: 140%;
        color: #000;
        display: inline-block;
        margin-bottom: 8px;
    }

    @media screen and (max-width: 760px) {
        margin-bottom: 32px;
    }
`;

const CardPostTitle = styled(BaseHeadingStyle)`
    font-size: ${props => (props.isWide ? '48' : '30')}px;
    line-height: 100%;
    color: #000;
    @media screen and (max-width: 760px) {
        font-size: ${props => (props.isWide ? '30' : '24')}px;
    }
`;

const ImageWrap = styled.div`
    margin-bottom: 16px;
    border-radius: 16px;
    overflow: hidden;

    .article-image {
        max-width: 100%;
        height: auto;
        display: block;
    }
`;

export const BaseBlogCard = ({
    title,
    date,
    smallImage,
    mediumImage,
    smallBackground,
    isWide,
}) => (
    <Card
        className={isWide ? 'base-card_wide' : ''}
        isWide={isWide}
        image={mediumImage}
        smallBackground={smallBackground}
    >
        {!isWide && (
            <ImageWrap>
                <Img className="article-image" fluid={smallImage} alt="" />
            </ImageWrap>
        )}
        <div className="base-card__title-wrap">
            <span className="base-card__date">{date}</span>
            <CardPostTitle
                as="h2"
                isWide={isWide}
                dangerouslySetInnerHTML={{ __html: title }}
            />
        </div>
    </Card>
);
